import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { useIsMobile } from '@sravni/react-utils';
import { useMemo } from 'react';

import { type TCreditFormCommonFields, useDictionaries } from 'src/client/entities/creditForm';

export const AutoModel: FC<IFieldFactoryProps> = ({ type, ...props }) => {
  const isMobile = useIsMobile();

  const { watch } = useFormContext<TCreditFormCommonFields>();
  const { autoModels } = useDictionaries(['autoModels']);
  const autoBrand = watch('autoBrand');
  const brandId = autoBrand?.value;
  const models = useMemo(() => (brandId ? (autoModels[brandId] ?? []) : []), [brandId, autoModels]);

  return (
    <ControlledCustomSelect
      {...props}
      name={type}
      options={models}
      mobile={isMobile}
    />
  );
};
